import { useQuery } from 'react-query';
import { getPrivateApi } from '../../../../../../../services/api';

export function useNetSuiteDepositToAccounts() {
  return useQuery(['netSuiteDepositToAccounts'], async () => {
    const api = getPrivateApi();
    const response = await api.netSuiteGetDepositToAccounts();
    return response.depositToAccounts;
  });
}
